import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/www/wwwroot/m.ichi-cake.com/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/www/wwwroot/m.ichi-cake.com/layouts/empty.vue").then(m => m.default || m)),
  "theme-vars": defineAsyncComponent(() => import("/www/wwwroot/m.ichi-cake.com/layouts/themeVars.ts").then(m => m.default || m))
}